import { PropsWithChildren } from 'react';
import { Logo } from './Logo';

type Props = {
  title: string;
};

export function View({ title, children }: PropsWithChildren<Props>) {
  return (
    <div className="w-full min-h-full flex flex-col items-center pt-12 xl:pt-24">
      <div className="w-72 xl:w-96 mb-8 xl:mb-14">
        <Logo />
      </div>
      <h2 className="text-xl xl:text-2xl uppercase tracking-widest">{title}</h2>

      {children}
    </div>
  );
}
